import { Space, TableColumnsType, Tag } from "antd";
import { IconButton, Tooltip } from "../../material-old";
import { EyeIcon } from "@heroicons/react/24/solid";
import { userGroupColors } from "./userGroupColors.ts";

export interface RecordRow {
  name: string;
  email: string;
  groups: string[];
  onClick: () => void;
}

export const USERS_TABLE_HEAD: TableColumnsType<RecordRow> = [
  {
    title: "Nombre",
    dataIndex: "name",
    key: "name",
    render: (_: any, record: RecordRow) => <Space>{record.name}</Space>,
    defaultSortOrder: "ascend",
    sorter: (a, b) => a.name.localeCompare(b.name),
    sortDirections: ["ascend", "descend"],
  },
  {
    title: "Correo",
    dataIndex: "email",
    key: "email",
    render: (_: any, record: RecordRow) => <Space>{record.email}</Space>,
    defaultSortOrder: "ascend",
    sorter: (a, b) => a.email.localeCompare(b.email),
    sortDirections: ["ascend", "descend"],
  },
  {
    title: "Grupos",
    dataIndex: "groups",
    key: "groups",
    render: (_: any, record: RecordRow) => {
      return (
        <Space>
          {record.groups.map((group) => (
            <Tag key={group} color={userGroupColors[group]}>
              {group}
            </Tag>
          ))}
        </Space>
      );
    },
  },
  {
    title: <span className="mx-auto flex justify-center">Acciones</span>,
    dataIndex: "detail",
    key: "detail",
    render: (_: any, record: RecordRow) => (
      <Space className="flex justify-center items-center w-full">
        <Tooltip content="Ver detalles">
          <IconButton variant="text" onClick={record.onClick}>
            <EyeIcon className="h-4 w-4" />
          </IconButton>
        </Tooltip>
      </Space>
    ),
  },
];
